import { entitiesSlice } from './entities-slice.js'
import * as thunks from './entities-thunks.js'

export const entitiesFeature = { thunks, actions: entitiesSlice.actions }
